import { createSlice } from '@reduxjs/toolkit';
// PDF
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
// Font (base64)
import { font, fontbold } from '../../assets/fonts/PTSerifRegular';

const DownloadSlice = createSlice({
  name: 'download',
  initialState: {
    filtervalue: null,
    filterpageindex: 0,
  },
  reducers: {
    setDtFilterValue: (state, action) => { state.filtervalue = action.payload; },
    setFilterPageIndex: (state, action) => { state.filterpageindex = action.payload; }
  },
});

export const { setDtFilterValue, setFilterPageIndex } = DownloadSlice.actions;
export default DownloadSlice.reducer;

// Ortak tablo oluşturucu (download & print için)
const buildPdf = ({ rowsPerPage, data, cols, pdftitle, filtervalue, filterpageindex }) => {
  const startindex = filterpageindex * rowsPerPage;
  const endindex = startindex + rowsPerPage;
  const doc = new jsPDF();

  // Font ekleme
  doc.addFileToVFS('PTSerif-Regular.ttf', font.trim());
  doc.addFont('PTSerif-Regular.ttf', 'PTSerif', 'normal');
  doc.addFileToVFS('PTSerif-Bold.ttf', fontbold.trim());
  doc.addFont('PTSerif-Bold.ttf', 'PTSerif', 'bold');
  doc.setFont('PTSerif', 'normal');

  // Başlık + tarih
  doc.setFontSize(14);
  doc.text(pdftitle, doc.internal.pageSize.getWidth() / 2, 15, { align: "center" });
  doc.setFontSize(10);
  doc.text(`Tarih: ${new Date().toLocaleDateString()}`, 14, 20);

  // Filtre
  const currentData = filtervalue
    ? data.filter(item =>
        Object.values(item).some(val => String(val).toLowerCase().includes(filtervalue.toLowerCase()))
      ).slice(startindex, endindex)
    : data.slice(startindex, endindex);

  const statusIndex = cols.findIndex(col => col.name === 'Status');
  const costIndex = cols.findIndex(col => col.name === 'Price');

  autoTable(doc, {
    head: [cols.map(col => col.name)],
    body: currentData.map(item => cols.map(col => item[col.value])),
    styles: { font: "PTSerif", valign: 'middle' },
    didParseCell: function (data) {
      if (data.column.index === statusIndex || data.column.index === costIndex) {
        data.cell.styles.font = 'PTSerif';
        data.cell.styles.fontStyle = 'bold';
        const statusText = data.row.raw[statusIndex];
        if (statusText !== undefined) {
          if (statusText.toString().includes("Gelen Ödeme")) {
            if (data.column.index === costIndex) data.cell.text = `+${data.cell.text}`;
            data.cell.styles.textColor = "green";
          } else if (statusText.toString().includes("Giden Ödeme")) {
            if (data.column.index === costIndex) data.cell.text = `-${data.cell.text}`;
            data.cell.styles.textColor = "red";
          }
        }
      }
    },
    margin: { top: 25 },
  });

  return doc;
};

// 📥 İNDİRME
export const exportPdfDownload = (params) => {
  const doc = buildPdf(params);
  doc.save(params.pdftitle + ".pdf");
};

//  YAZDIR
export const exportPdfPrint = (params) => {
  const doc = buildPdf(params);
  doc.autoPrint();
  window.open(doc.output("bloburl"), "_blank");
};
